import { ApolloError } from '@apollo/client';
import identity from 'lodash/identity';
import { ActionName } from 'services/observability/types';
import { datadogReporter } from 'services/observability/reporters';

const { runWithReporting } = datadogReporter;

/*
  Assumes default datadog reporting for network errors are sufficient.
*/
const reportRequestErrors = (error: ApolloError | undefined) => {
  // Catch error cases misrepresented by 200 status
  if (error) {
    throw new Error('Response contains errors');
  }
};

export const createErrorMonitor = (graphQLAction?: ActionName) =>
  runWithReporting<[ApolloError | undefined], void>(
    graphQLAction || { name: 'unspecified' },
    identity,
    reportRequestErrors,
    { errorsOnly: true },
  );
